import { render, staticRenderFns } from "./studyInfoProtector.vue?vue&type=template&id=088dfc89&scoped=true&"
import script from "./studyInfoProtector.vue?vue&type=script&lang=js&"
export * from "./studyInfoProtector.vue?vue&type=script&lang=js&"
import style0 from "./studyInfoProtector.vue?vue&type=style&index=0&id=088dfc89&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088dfc89",
  null
  
)

export default component.exports